import clsx from "clsx";
import { formatPrice } from "@/utils/utils";
import type { PriceRange } from "@/types/cart";

//#region Type
interface ProductPriceProps {
  price: string | number; // 目前實際生效的價格, 若有特價，則等於特價價格
  regular_price: string | number;
  on_sale: boolean;
  price_range?: PriceRange | null;
  size?: "sm" | "lg";
}
//#endregion

const ProductPrice = ({
  price,
  regular_price = "",
  on_sale,
  price_range = null,
  size = "sm",
}: ProductPriceProps) => {
  if (price_range) {
    return (
      <span
        className={clsx("brand-text-sm font-bold text-accent", size === "lg" && "brand-heading-md")}
      >
        {`${formatPrice(price_range.min_amount)} -  ${formatPrice(price_range.max_amount)}`}
      </span>
    );
  }

  return (
    <div className="flex items-baseline gap-1">
      <span
        className={clsx(
          "brand-text-sm font-bold text-accent",
          on_sale && "text-xs font-normal text-neutral line-through",
          size === "lg" && "brand-heading-md order-2",
        )}
      >
        {formatPrice(regular_price)}
      </span>
      {on_sale && (
        <span
          className={clsx(
            "brand-text-sm font-bold text-accent",
            size === "lg" && "brand-heading-md order-1",
          )}
        >
          {formatPrice(price)}
        </span>
      )}
    </div>
  );
};

export default ProductPrice;
